import { render, staticRenderFns } from "./ReviewTracker.vue?vue&type=template&id=ba1eb7b4&"
import script from "./ReviewTracker.vue?vue&type=script&lang=ts&"
export * from "./ReviewTracker.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewTracker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports